module.exports = __webpack_public_path__ + "img/smg03_samurai02_shop.70ad03c8.png";